import { useEffect } from 'react';

interface Props {
  enabled: boolean;
}

const useClipContentHeight = ({ enabled }: Props) => {
  const clipContentHeight = () => {
    let contentBounds: any;
    let windowHeight: any;
    let newHeight = 'calc(100vh + 100px)';

    if (typeof document !== 'undefined') {
      contentBounds = document.querySelector('.rendered-post')?.getBoundingClientRect();
      windowHeight = window?.innerHeight;

      if (contentBounds && contentBounds.bottom + window.scrollY < windowHeight) {
        newHeight = '100vh';
      }

      const bodyEl = document.querySelector('body');
      const htmlEl = document.querySelector('html');

      if (bodyEl) {
        window.scrollTo(0, 0);
        bodyEl.style.height = newHeight;
        bodyEl.style.overflow = 'hidden';
        bodyEl.style.userSelect = 'none';
      }

      if (htmlEl) {
        htmlEl.style.overflow = 'auto';
      }
    }
  };

  const resetContentHeight = () => {
    const bodyEl = document.querySelector('body');
    const htmlEl = document.querySelector('html');

    if (bodyEl) {
      bodyEl.style.height = '';
      bodyEl.style.overflow = '';
      bodyEl.style.userSelect = '';
    }

    if (htmlEl) {
      htmlEl.style.overflow = '';
    }
  };

  useEffect(() => {
    if (enabled) {
      clipContentHeight();
    } else {
      resetContentHeight();
    }

    return () => {
      if (enabled) {
        resetContentHeight();
      }
    };
  }, [enabled]);
};

export default useClipContentHeight;
